import React from 'react';

const StreakCard = ({ streak, bestStreak, totalDays }) => {
  const nextMilestone = Math.ceil(streak / 10) * 10 || 10;
  const progress = Math.min((streak / nextMilestone) * 100, 100);

  return (
    <div className="bg-gradient-to-br from-brand-500 to-brand-600 rounded-2xl p-8 text-white shadow-lg">
      <p className="text-center text-brand-100 text-sm font-medium mb-2">
        🔥 הרצף שלך
      </p>
      <h2 className="text-center text-7xl font-bold mb-2 font-display">{streak}</h2>
      <p className="text-center text-brand-100 text-lg font-semibold mb-6">
        ימים נקיים
      </p>

      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex justify-between items-center mb-2">
          <span className="text-sm text-brand-100">עד {nextMilestone} ימים</span>
          <span className="text-sm font-semibold">{Math.round(progress)}%</span>
        </div>
        <div className="w-full bg-brand-400 bg-opacity-30 rounded-full h-2">
          <div
            className="bg-white rounded-full h-2 transition-all duration-700"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <p className="text-center text-brand-50 text-sm">
        עוד {nextMilestone - streak} ימים ל-{nextMilestone}! 💪
      </p>

      {/* Mini Stats Row */}
      <div className="mt-4 pt-4 border-t border-brand-400 border-opacity-40 grid grid-cols-2 gap-4">
        <div className="text-center">
          <p className="text-brand-100 text-xs">🏆 הרצף הטוב ביותר</p>
          <p className="font-bold text-xl">{bestStreak}</p>
        </div>
        <div className="text-center">
          <p className="text-brand-100 text-xs">📅 סה"כ ימים שתועדו</p>
          <p className="font-bold text-xl">{totalDays}</p>
        </div>
      </div>
    </div>
  );
};

export default StreakCard;
